import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, TextField, RadioGroup, Radio, FormGroup } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";
import ModalHeader from "../../../Modal/ModalHeader/ModalHeader";

export default function StepOne(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

    useEffect(() => {
        if (props.datas.activity) {
            buttons[1].disabled = false;
        } else {
            buttons[1].disabled = true;
        }
        setButtons([...buttons]);
    }, [props.datas]);

    function handleActivityChange(e) {
        let datas = Object.assign({}, props.datas);
        datas[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Votre activité principale fait-elle partie des activités suivantes ?
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="gender"
                        defaultValue={props.datas.activity}
                        name="radio-buttons-group">
                        <FormControlLabel
                            value="Fourniture de services de gestions aux  locations de logements à court et moyen terme (ex : agence immobilière, conciergerie, loueur/sous-louer…)"
                            control={<Radio name='activity'
                                onChange={(e) => handleActivityChange(e)} />}
                            label="Fourniture de services de gestions aux  locations de logements à court et moyen terme (ex : agence immobilière, conciergerie, loueur/sous-louer…)" />
                        <FormControlLabel
                            value="Fourniture de services de restauration aux  locations de logements à court et moyen terme"
                            control={
                                <Radio name='activity'
                                    onChange={(e) => handleActivityChange(e)} />}
                            label="Fourniture de services de restauration aux  locations de logements à court et moyen terme" />
                        <FormControlLabel
                            value="Fourniture de services de nettoyage aux  locations de logements à court et moyen terme"
                            control={
                                <Radio name='activity'
                                    onChange={(e) => handleActivityChange(e)} />}
                            label="Fourniture de services de nettoyage aux  locations de logements à court et moyen terme" />
                        <FormControlLabel
                            value="Fourniture de services comptables/fiscaux aux  locations de logements à court et moyen terme"
                            control={
                                <Radio name='activity'
                                    onChange={(e) => handleActivityChange(e)} />}
                            label="Fourniture de services comptables/fiscaux aux  locations de logements à court et moyen terme" />
                        <FormControlLabel
                            value="Fourniture d’autres services aux  locations de logements à court et moyen terme"
                            control={
                                <Radio name='activity'
                                    onChange={(e) => handleActivityChange(e)} />}
                            label="Fourniture d’autres services aux  locations de logements à court et moyen terme" />
                        <TextField
                            id="outlined-multiline-static"
                            label="Autres : Veuillez préciser"
                            name='otherActivity'
                            multiline
                            rows={3}
                            onChange={(e) => handleActivityChange(e)}
                        />
                    </RadioGroup>
                </FormControl>
            </Typography>
            <ModalFooter buttons={buttons} />
        </>
    )
}